import request from '../utils/request';

//常见问题列表
export const problemList = params => {
    return request({
        url: '/admin/problem/list',
        method: 'post',
        data:params
    });
};

//常见问题标签  
export const getTagList = (experienceType) => {
    return request({
        url: `/admin/problem/label_list/${experienceType}/1`,
        method: 'get'
    });
};
//常见问题类型 
export const getTypeList = (experienceType) => {
    return request({
        url: `/admin/problem/type_list/${experienceType}/1`,
        method: 'get'
    });
};